import { QuestionCodeAnswer } from "../models";

export class SecretQuestionAnswers {
    userId: string;
    questionCodeAnswers: QuestionCodeAnswer[]
}


// WEBPACK FOOTER //
// ./src/app/models/secretQuestionAnswers.ts